'use strict';

module.exports = '2.28.0';



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch-helper/src/version.js
// module id = 715
// module chunks = 0 1 2 3 4 5 6 7 8